import styled from "styled-components";
import {Col} from 'react-bootstrap';
import {NavLink} from "react-router-dom";
export const SliderContainer = styled.div`
  width: 100%;
  min-height: max(600px, 100svh);
  display: flex;
  align-items: center;
  padding: clamp(3rem, 8vw, 7rem) 1rem;
  background-color: #171717;
  @media (max-width: 991.98px) {
    min-height: max(500px, 100svh);
  }
  position: relative;
  background-repeat: no-repeat;
  background-position: 70% top;
  background-image: linear-gradient(rgba(0,0,0,.25), rgba(0,0,0,.45)), url("/assets/img/myroullette-slider.jpg");
  background-size: cover;
`;
export const SectionContainer = styled.section`
  width: 100%;
  padding: clamp(2.5rem, 5vw, 5rem) 0;
  overflow-wrap: anywhere;
  & .container {
    padding-inline: clamp(1rem, 3vw, 2rem);
  }
  & .row > * { min-width: 0; }
  & .row { row-gap: 1.5rem; }
  background: ${(props) => props.bg === "white"?"#fff":(props.bg === "gray"?"#f1f1f1":"#242424")};
  ${(props) => props.bg === "white" || props.bg === "gray"?`
    & .wrapper{
      width: fit-content;
      background: #f7f7f7;
      margin: 0 auto;
      padding: .5em 1em .7em 1em;
      border-radius: 10px;
      max-width: 100%;
      min-width: min(200px, 100%);
   
    }
    & .right{
      width: fit-content;
      background: #f7f7f7;
      padding: .5em 1em .7em 1em;
      border-radius: 10px;
      max-width: 100%;
      min-width: min(200px, 100%);
   
    }
  `:`
    color: #d0cecf;
    & .wrapper{
      width: fit-content;
      background: #323232;
      margin: 0 auto;
      padding: .5em 1em .7em 1em;
      border-radius: 10px;
      max-width: 100%;
      min-width: min(200px, 100%);
    }
  `};
  &:last-child{
    padding-bottom: 5em;
  }
`;
export const ResultContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
`
export const DrawResultTitle = styled.h5`
  font-size: 2.5em;
  font-weight: 700;
  @media screen and (max-width: 767.98px) {
    text-align: center;
    font-size: 2em;
  }
  & span{
    display: block;
    font-size: 0.8em;
    margin-bottom: 4px;
  }
`;

export const StepsContainer = styled.div`
  width: 100%;
  
`;

export const CenterCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const SectionTitle = styled.h2`
  font-size: clamp(1.4rem, 2.5vw, 1.8rem);
  font-weight: 700;
  text-align: center;
  margin-bottom: 1em;
  position: relative;
  
  @media screen and (max-width: 767.98px) {
    text-align: center;
  }
`
export const SectionBody = styled.div`
  padding: 1.5em 0;  
  font-size: 1.1em;
  font-weight: 500;
  text-align: start;
  line-height: 1.7em;
  @media screen and (max-width: 767.98px) {
    & .sm-order-2{
      order: 2;
    }
    & .sm-order-1{
      order: 1;
    }
  }
`
export const Brand = styled.div`
  text-align: center;
  margin-bottom: 2em;
  & img{
    width: min(100%, 220px);
    height: auto;
    margin-bottom: .7em;
  }
`
export const StepsTitle = styled.h3`
  color: var(--color-secondary);
  font-size: clamp(1.4rem, 2.5vw, 1.8rem);
  font-weight: 700;
  @media screen and (max-width: 767.98px) {
    text-align: center;
  }
`
export const StepsList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 767.98px) {
    display: block;
  }
`
export const StepItem = styled.li`
  display: flex;
  align-items: center;
  ${(props) => (props.full)?`width: 66%;`:`width: 33%;`}
  margin-top: 1em;
  @media screen and (max-width: 767.98px) {
    display: block;
    width: 100%;
    text-align: center;
  }
`
export const StepNumber = styled.div`
  width: 60px;
  height: 60px;
  min-width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  color: #333;
  font-size: 1.5em;
  font-weight: 500;
  border-radius: 100%;
  @media screen and (max-width: 767.98px) {
    margin: 1em auto;
  }
`
export const StepDescription = styled.div`
  margin: 1em;
  font-size: 1.1em;
  font-weight: 600;
`
export const StepSubDescription = styled.div`
  color: var(--color-secondary);
`


export const GetStarted = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const GetStartedWrapper = styled.div`
  text-align: center;
  width: 100%;
  max-width: 960px;
  overflow-wrap: anywhere;
  & h1{
    font-size: clamp(2rem, 5vw, 4rem);
    line-height: 1.3;
    color: #fff;
    font-weight: 700;
    margin-bottom: 1em;
  }
  & a{
    display: inline-block;
    max-width: 100%;
    border-radius: 8px;
    background: #fff;
    color: #333;
    padding: 1em 2em;
    font-weight: 700;
    transition: all ease-in-out .3s;
    font-size: 1.2em;
    &:hover{
      background: var(--color-primary);
      color: #fff;
      transition: all ease-in-out .3s;
    }
  }
`
export const PrimaryButton = styled(NavLink)`
  background: var(--color-primary);
  color: #fff;
  padding: .7em 2em;
  max-width: 100%;
  border-radius: 8px;
  text-align: center;
  overflow-wrap: anywhere;
  display: inline-block;
  transition: all ease-in-out .3s;
  margin: 1em .3em;
  &:hover{
    background: #fff;
    color: #333;
    transition: all ease-in-out .3s;
  }
`
export const PrimaryLink = styled.a`
  background: var(--color-primary);
  color: #fff;
  padding: .7em 2em;
  max-width: 100%;
  border-radius: 8px;
  text-align: center;
  overflow-wrap: anywhere;
  display: inline-block;
  transition: all ease-in-out .3s;
  margin: 1em .3em;
  &:hover{
    background: #fff;
    color: #333;
    transition: all ease-in-out .3s;
  }
`
export const SecondaryButton = styled(NavLink)`
  background: var(--color-primary);
  color: #fff;
  padding: .7em 2em;
  max-width: 100%;
  border-radius: 8px;
  text-align: center;
  overflow-wrap: anywhere;
  display: inline-block;
  transition: all ease-in-out .3s;
  margin: 1em .3em;
  &:hover{
    background: #333;
    color: #fff;
    transition: all ease-in-out .3s;
  }
`
export const SecondaryLink = styled.a`
  background: var(--color-primary);
  color: #fff;
  padding: .7em 2em;
  max-width: 100%;
  border-radius: 8px;
  text-align: center;
  overflow-wrap: anywhere;
  display: inline-block;
  transition: all ease-in-out .3s;
  margin: 1em .3em;
  &:hover{
    background: #333;
    color: #fff;
    transition: all ease-in-out .3s;
  }
`
export const CenterText = styled.div`
  text-align: center;
`
export const FlexButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .75rem;
  margin-top: 1rem;
  & a { margin: 0; }
  @media (max-width: 575.98px) {
    & a { width: 100%; }
  }
  justify-content: center;
  align-items: center;
`
export const Brands = styled.div`
  max-width: 80%;
  margin: 1em auto;
  text-align: center;
`
export const ContactItem = styled.div`
  margin: .3em 0;
  text-align: center;
`
export const ContactItemTitle = styled.h3`
  font-weight: 700;
  margin-bottom: 1em;
  ${(props) => props.ltr && `
    direction: ltr;
    text-align: right;
  `}
  ${(props) => props.center && `
    text-align: center;
  `}
  
`
export const ContactItemBody = styled.div`
  ${(props) => props.center && `
    text-align: center;
    justify-content: center;
  `}
`
export const ContactItemIcon = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-items: center;
  & div{
    width: 48px;
    height: 48px;
    border: 2px solid #333;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    & svg{
      font-size: 20px;
    }
  }
`
export const ContactItemText = styled.div`
  & h3{
    font-size: 1em;
    font-weight: 600;
    margin-bottom: .4em;
    text-align: center;
    margin-top: 1em;
  }
  & a{
    display: block;
    color: #333;
    transition: all ease-in-out .3s;
    &:hover{
      color: var(--color-primary);
      transition: all ease-in-out .3s;
    }
  }
  & small{
    font-size: .8em;
    color: #7a7a7a;
  }
`
export const ColImage = styled.div`
  text-align: center;
  margin: 0;
  & img {
    display: block;
    width: 100%;
    max-width: 560px;
    height: auto;
    margin: 0 auto;
    border-radius: 12px;
  }
`